import gql from 'graphql-tag';

export const GET_ARTIST = gql`
  query Artist (
    $id: ID,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $keyName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String
  ) {
    Artist(
      id: $id,
      dpid: $dpid,
      isni: $isni,
      ipi: $ipi,
      ipn: $ipn,
      musicbrainzGuid: $musicbrainzGuid,
      cisacSocietyID: $cisacSocietyID,
      fullName: $fullName,
      keyName: $keyName,
      abbreviatedName: $abbreviatedName,
      description: $description,
      postalAddressLine: $postalAddressLine,
      postalCityName: $postalCityName,
      postalDistrictName: $postalDistrictName,
      postCode: $postCode,
      postalTerritoryCode: $postalTerritoryCode,
      phoneNumber: $phoneNumber,
      emailAddress: $emailAddress,
      website: $website
    ) {
      id,
      dpid,
      isni,
      ipi,
      ipn,
      musicbrainzGuid,
      cisacSocietyID,
      fullName,
      keyName,
      abbreviatedName,
      description,
      postalAddressLine,
      postalCityName,
      postalDistrictName,
      postCode,
      postalTerritoryCode,
      phoneNumber,
      emailAddress,
      website,
      assets {
        __typename
        ...on Project {
          id,
          title
        }
        ...on Share {
          id,
          percent,
          territoryCode,
          work {
            id,
            title
          }
        }
        ... on ReleaseDetail {
          release {
            id,
            title,
            type,
            isMainRelease,
            releaseDetails {
              id,
              artwork {
                id,
                file {
                  uri
                }
              }
            }
          }
        }
      }
      contributions {
        id,
        role,
        featured,
        contracted,
        isCredited,
        contributedTo {
          __typename
          ...on Component {
            id,
            title
          }
          ...on Work {
            id,
            title
          }

        }
      }
    }
  }
`;

export const CREATE_ARTIST = gql`
  mutation createArtist (
    $id: ID,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $keyName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String
  ) {
    CreateArtist(
      id: $id,
      dpid: $dpid,
      isni: $isni,
      ipi: $ipi,
      ipn: $ipn,
      musicbrainzGuid: $musicbrainzGuid,
      cisacSocietyID: $cisacSocietyID,
      fullName: $fullName,
      keyName: $keyName,
      abbreviatedName: $abbreviatedName,
      description: $description,
      postalAddressLine: $postalAddressLine,
      postalCityName: $postalCityName,
      postalDistrictName: $postalDistrictName,
      postCode: $postCode,
      postalTerritoryCode: $postalTerritoryCode,
      phoneNumber: $phoneNumber,
      emailAddress: $emailAddress,
      website: $website
    ) {
      id,
      dpid,
      isni,
      ipi,
      ipn,
      musicbrainzGuid,
      cisacSocietyID,
      fullName,
      keyName,
      abbreviatedName,
      description,
      postalAddressLine,
      postalCityName,
      postalDistrictName,
      postCode,
      postalTerritoryCode,
      phoneNumber,
      emailAddress,
      website
    }
  }
`;

export const UPDATE_ARTIST = gql`
  mutation updateArtist (
    $id: ID!,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $keyName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String
  ) {
    UpdateArtist(
      id: $id,
      dpid: $dpid,
      isni: $isni,
      ipi: $ipi,
      ipn: $ipn,
      musicbrainzGuid: $musicbrainzGuid,
      cisacSocietyID: $cisacSocietyID,
      fullName: $fullName,
      keyName: $keyName,
      abbreviatedName: $abbreviatedName,
      description: $description,
      postalAddressLine: $postalAddressLine,
      postalCityName: $postalCityName,
      postalDistrictName: $postalDistrictName,
      postCode: $postCode,
      postalTerritoryCode: $postalTerritoryCode,
      phoneNumber: $phoneNumber,
      emailAddress: $emailAddress,
      website: $website
    ) {
      id,
      dpid,
      isni,
      ipi,
      ipn,
      musicbrainzGuid,
      cisacSocietyID,
      fullName,
      keyName,
      abbreviatedName,
      description,
      postalAddressLine,
      postalCityName,
      postalDistrictName,
      postCode,
      postalTerritoryCode,
      phoneNumber,
      emailAddress,
      website
    }
  }
`;

export const DELETE_ARTIST = gql`
  mutation deleteArtist (
    $id: ID!
  ) {
  DeleteArtist(
    id: $id
  ) {
    id
  }
}
`;

// AddArtistTextDepictions(
//   from: _TextInput!
//   to: _ArtistInput!
// ): _AddArtistTextDepictionsPayload
// RemoveArtistTextDepictions(
//   from: _TextInput!
//   to: _ArtistInput!
// ): _RemoveArtistTextDepictionsPayload
// AddArtistImageDepictions(
//   from: _ImageInput!
//   to: _ArtistInput!
// ): _AddArtistImageDepictionsPayload
// RemoveArtistImageDepictions(
//   from: _ImageInput!
//   to: _ArtistInput!
// ): _RemoveArtistImageDepictionsPayload
// AddArtistVideoDepictions(
//   from: _VideoInput!
//   to: _ArtistInput!
// ): _AddArtistVideoDepictionsPayload
// RemoveArtistVideoDepictions(
//   from: _VideoInput!
//   to: _ArtistInput!
// ): _RemoveArtistVideoDepictionsPayload
// AddArtistProjects(
//   from: _ArtistInput!
//   to: _ProjectInput!
// ): _AddArtistProjectsPayload
// RemoveArtistProjects(
//   from: _ArtistInput!
//   to: _ProjectInput!
// ): _RemoveArtistProjectsPayload
// AddArtistContributions(
//   from: _ArtistInput!
//   to: _ContributionInput!
// ): _AddArtistContributionsPayload
// RemoveArtistContributions(
//   from: _ArtistInput!
//   to: _ContributionInput!
// ): _RemoveArtistContributionsPayload
// AddArtistWorksPublished(
//   from: _ArtistInput!
//   to: _WorkInput!
// ): _AddArtistWorksPublishedPayload
// RemoveArtistWorksPublished(
//   from: _ArtistInput!
//   to: _WorkInput!
// ): _RemoveArtistWorksPublishedPayload
// AddArtistReleases(
//   from: _ArtistInput!
//   to: _ReleaseDetailInput!
// ): _AddArtistReleasesPayload
// RemoveArtistReleases(
//   from: _ArtistInput!
//   to: _ReleaseDetailInput!
// ): _RemoveArtistReleasesPayload
// AddArtistReleasesOwned(
//   from: _ArtistInput!
//   to: _ReleaseDetailInput!
// ): _AddArtistReleasesOwnedPayload
// RemoveArtistReleasesOwned(
//   from: _ArtistInput!
//   to: _ReleaseDetailInput!
// ): _RemoveArtistReleasesOwnedPayload
// AddArtistRightsShares(
//   from: _ArtistInput!
//   to: _ShareInput!
// ): _AddArtistRightsSharesPayload
// RemoveArtistRightsShares(
//   from: _ArtistInput!
//   to: _ShareInput!
// ): _RemoveArtistRightsSharesPayload
// AddArtistRightsControlled(
//   from: _ArtistInput!
//   to: _ShareInput!
// ): _AddArtistRightsControlledPayload
// RemoveArtistRightsControlled(
//   from: _ArtistInput!
//   to: _ShareInput!
// ): _RemoveArtistRightsControlledPayload
// AddArtistRightsAdministered(
//   from: _ArtistInput!
//   to: _ShareInput!
// ): _AddArtistRightsAdministeredPayload
// RemoveArtistRightsAdministered(
//   from: _ArtistInput!
//   to: _ShareInput!
// ): _RemoveArtistRightsAdministeredPayload
// AddArtistInstrumentsMade(
//   from: _InstrumentInput!
//   to: _ArtistInput!
// ): _AddArtistInstrumentsMadePayload
// RemoveArtistInstrumentsMade(
//   from: _InstrumentInput!
//   to: _ArtistInput!
// ): _RemoveArtistInstrumentsMadePayload
// AddArtistEquipmentMade(
//   from: _EquipmentInput!
//   to: _ArtistInput!
// ): _AddArtistEquipmentMadePayload
// RemoveArtistEquipmentMade(
//   from: _EquipmentInput!
//   to: _ArtistInput!
// ): _RemoveArtistEquipmentMadePayload
// AddArtistPaymentsMade(
//   from: _ArtistInput!
//   to: _PaymentInput!
// ): _AddArtistPaymentsMadePayload
// RemoveArtistPaymentsMade(
//   from: _ArtistInput!
//   to: _PaymentInput!
// ): _RemoveArtistPaymentsMadePayload
// AddArtistPaymentsReceived(
//   from: _PaymentInput!
//   to: _ArtistInput!
// ): _AddArtistPaymentsReceivedPayload
// RemoveArtistPaymentsReceived(
//   from: _PaymentInput!
//   to: _ArtistInput!
// ): _RemoveArtistPaymentsReceivedPayload
// AddArtistGenres(
//   from: _GenreInput!
//   to: _ArtistInput!
// ): _AddArtistGenresPayload
// RemoveArtistGenres(
//   from: _GenreInput!
//   to: _ArtistInput!
// ): _RemoveArtistGenresPayload
// AddArtistFeaturedBy(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _AddArtistFeaturedByPayload
// RemoveArtistFeaturedBy(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _RemoveArtistFeaturedByPayload
// AddArtistLabels(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _AddArtistLabelsPayload
// RemoveArtistLabels(
//   from: _LabelInput!
//   to: _ArtistInput!
// ): _RemoveArtistLabelsPayload
